import { useQuery } from "@tanstack/react-query";
import { fetchControlPlaneVersion } from "@/lib/api/version";
import { queryKeys } from "@/lib/api/queryKeys";

export function BuildVersionFooter() {
  const web = import.meta.env.VITE_APP_VERSION?.trim() || "dev";
  const apiQuery = useQuery({
    queryKey: queryKeys.controlPlaneVersion(),
    queryFn: fetchControlPlaneVersion,
    staleTime: Number.POSITIVE_INFINITY,
    retry: 1,
  });
  const api = apiQuery.data ?? null;

  return (
    <footer className="border-t border-outline-variant/50 bg-background px-3 py-1.5">
      <p className="mx-auto max-w-6xl text-center font-mono text-[11px] leading-4 text-muted-foreground break-all">
        <span className="block sm:inline">web {web}</span>
        {api ? (
          <span className="block sm:ml-3 sm:inline">api {api}</span>
        ) : null}
      </p>
    </footer>
  );
}
